/* Core & libraries */
import React, {useEffect, useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";


/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";
import { ReactComponent as MailIconSvg } from '../../../resources/images/mail-icon.svg';

/* Styles */
import styles from "./styles";

const AddDomainModal = ({showModal, setShowModal, handleAdd}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
      <UCModal
        className={classes.createDomainModal}
        showModal={ showModal }
        setShowModal={ setShowModal }
        modalIcon={ <MailIconSvg /> }
        modalTitle={ <FormattedMessage id="settings.domains.add.title"/> }
        modalContent={ <Content setShowModal={setShowModal} handleSubmit={handleAdd} /> }
        dataTestId="addDomainModal"
      />
  )
}

export default AddDomainModal;
